<template>
  <article class="px-0 py-0 my-0">
    <section class="px-7 px-xl-9 py-14 m-0">
      <div style="max-width:704px" class="mx-auto">
        <h2 class="by-heading-2 text-by-blue-100 mb-5">Nutzungsbedingungen für das Portal „open.bydata" und „[you].bydata"</h2>
      </div>
    </section>
    <section class="m-0 py-11 px-7 px-xl-9 bg-by-neutral-10">
      <div style="max-width:704px" class="mx-auto">
        <h3 class="by-heading-3 text-by-blue-100 mb-4">Wofür gelten diese Nutzungsbedingungen?</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Diese Nutzungsbedingungen gelten für das Portal „open.bydata" unter der Domain
          <a href="http://open.bydata.de">http://open.bydata.de</a>
          und „[you].bydata.de" bzw. „opendata.bayern" (im Folgenden: <b>„open.bydata"</b> oder <b>„das Portal"</b>).
        </p>

        <h3 class="by-heading-3 text-by-blue-100 mb-4">Wer ist Betreiber des Portals?</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          <b>Betreiber</b> des Portals ist die byte – BAYERISCHE AGENTUR FÜR DIGITALES GMBH,
          Orleansstraße 24, 81669 München.
        </p>

        <h3 class="by-heading-3 text-by-blue-100 mb-4">Begriffsbestimmungen</h3>
        <ol class="text-by-neutral-100 by-copy-small-regular mb-9 pl-4">
          <li>
            <b>Daten</b> im Sinne des Portals sind offene Daten, Datensätze und Dokumente mit Bezug
            zum Freistaat Bayern, die von verschiedenen Anbietern aus dem öffentlichen und privaten Sektor
            bereitgestellt werden.
          </li>
          <li>
            <b>Datenbereitsteller</b> sind natürliche oder juristische Personen, Behörden oder Organisationen,
            die die Daten im Sinne dieser Nutzungsbedingungen bereitstellen.
          </li>
          <li>
            <b>Nutzer</b> ist jede natürliche oder juristische Person, die auf die zur Verfügung gestellten Daten zugreift.
          </li>
        </ol>

        <h3 class="by-heading-3 text-by-blue-100 mb-4">Welche Funktion hat das Portal?</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          open.bydata ermöglicht Nutzern einen einfachen und unentgeltlichen Zugang zu offenen Daten
          mit Bezug zum Freistaat Bayern von Datenbereitstellern. Zentraler Bestandteil von open.bydata
          ist ein systematisierter Datenkatalog. Über dessen standardisierte Metadaten, d.h. spezifische
          Beschreibungen von Rohdaten, sind die Daten einfach auffindbar. Nutzer können über Links
          oder Schnittstellen auf die Daten der Datenbereitsteller zugreifen.
        </p>

        <h3 class="by-heading-3 text-by-blue-100 mb-4">Was gilt für die Nutzung des Portals?</h3>
        <ol class="text-by-neutral-100 by-copy-small-regular mb-9 pl-4">
          <li>
            Die Daten selbst werden nicht vom Betreiber, sondern dezentral auf Datenspeichern des jeweiligen
            <b>Datenbereitstellers</b> angeboten und vorgehalten. Die im Datenkatalog enthaltenen Metadaten
            verweisen auf beim jeweiligen Datenbereitsteller vorgehaltene Daten oder eine Schnittstelle
            des Datenbereitstellers.
          </li>
          <li>
            Greift ein Nutzer auf von einem Datenbereitsteller zur Verfügung gestellte Daten zu, entstehen
            etwaige rechtliche Beziehungen hinsichtlich der abgerufenen Daten lediglich zwischen dem Nutzer
            und dem Datenbereitsteller, nicht zwischen Nutzer und Betreiber. Es gelten insoweit die
            Nutzungsbedingungen des Datenbereitstellers, die i.d.R. über die Angabe einer entsprechenden
            freien Lizenz im Portal geregelt sind.
          </li>
          <li>
            Das Portal wird laufend weiterentwickelt. Der Betreiber behält sich vor, die auf dem Portal
            angebotenen Dienste zu ändern, abweichende Dienste anzubieten oder diese ganz einzustellen
            und gewährleistet keine Erreichbarkeit seines Servers oder der von den Datenbereitstellern
            zur Verfügung gestellten Daten.
          </li>
        </ol>

        <h3 class="by-heading-3 text-by-blue-100 mb-4">Wer haftet wofür?</h3>
        <ol class="text-by-neutral-100 by-copy-small-regular mb-9 pl-4">
          <li>
            Der Betreiber kann den Inhalt der Daten eines Datenbereitstellers vor der Veröffentlichung
            in open.bydata lediglich stichprobenartig prüfen. Erlangt der Betreiber Kenntnis über
            Rechtsverletzungen, wird er den Zugang zu den betroffenen Daten nicht weiter ermöglichen.
          </li>
          <li>
            Im Übrigen ist der Betreiber nicht für die Inhalte der von den Datenbereitstellern zur
            Verfügung gestellten Daten verantwortlich. Widersprüche und sonstige Anfragen sind an den
            jeweiligen Datenbereitsteller zu richten.
          </li>
          <li>
            Der Betreiber ermöglicht mit dem Betrieb der Plattform lediglich den Kontakt zu
            Datenbereitstellern und macht sich deren Daten nicht zu eigen und stellt diese Daten auch
            nicht über eigene Server zur Verfügung. Es entsteht hinsichtlich der Verwendung der Daten
            kein Rechtsverhältnis zwischen dem Nutzer und dem Betreiber
            (siehe auch ‚Was gilt für die Nutzung des Portals?‘ Abs. 2). Deshalb haftet der Betreiber
            nicht für die Richtigkeit und Vollständigkeit der von Datenbereitstellern zur Verfügung
            gestellten Daten.
          </li>
          <li>
            Er haftet auch nicht für Schäden, die durch die Nutzung der von Datenbereitstellern zur
            Verfügung gestellten Daten entstehen. Er haftet darüber hinaus nicht für Schäden, die beim
            Aufrufen oder Herunterladen von Computerviren enthaltende Daten der Datenbereitsteller oder
            bei der Installation oder Nutzung von Software von Webseiten der Datenbereitsteller
            verursacht werden.
          </li>
          <li>
            Der Betreiber haftet unbeschränkt für Schäden, die auf Vorsatz oder grober Fahrlässigkeit
            beruhen. Der Betreiber haftet für leichte Fahrlässigkeit bei Schäden aus der Verletzung
            des Lebens, des Körpers oder der Gesundheit von Personen.
          </li>
        </ol>

        <h3 class="by-heading-3 text-by-blue-100 mb-4">Änderung dieser Nutzungsbedingungen</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Der Betreiber behält sich vor, diese Nutzungsbedingungen zu ändern, wenn dies aufgrund
          technischer oder organisatorischer Änderungen oder der Änderung rechtlicher Anforderungen
          erforderlich ist. Änderungen werden auf dem Portal veröffentlicht.
        </p>
      </div>
    </section>
  </article>
</template>
<script>

export default {
  name: "TermsOfUse",
  metaInfo() {
    const title = "Nutzungsbedingungen - open.bydata";
    return {
      titleTemplate(chunk) {
        return title;
      },
    };
  }
}
</script>

<style scoped>
@import "../styles/static_pages.scss";
</style>
